import React from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  modalName: string;
  children: React.ReactNode;
}

const EmptyModal: React.FC<ModalProps> = ({ isOpen, onClose, modalName, children }) => {
  return (
    <div>
      <input
        type="checkbox"
        id={modalName}
        className="modal-toggle"
        checked={isOpen}
        onChange={onClose}
      />
      <div className={`modal modal-bottom sm:modal-middle ${isOpen ? 'active' : ''}`}>
        <div className="modal-box">{children}</div>
      </div>
    </div>
  );
};

export default EmptyModal;
